import { render } from "./RegisterParticipante.vue?vue&type=template&id=5a0c44db"
import script from "./RegisterParticipante.vue?vue&type=script&lang=js"
export * from "./RegisterParticipante.vue?vue&type=script&lang=js"
script.render = render

export default script